import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, IdCard } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { BENEFITS } from "@/data/content";

export default function Benefits({ embedded }) {
  const featured = BENEFITS.filter((b) => b.featured);
  const rest = BENEFITS.filter((b) => !b.featured);

  return (
    <div>
      {!embedded && (
        <PageHeader
          eyebrow="Member Benefits"
          title="What membership in the Trust confers."
          subtitle="Verified constituents receive recognition, permanence, and the instruments of Independent Economic Sovereignty — anchored by the Modern Freedmen Bureau."
        />
      )}

      <section className="py-20 bg-ink">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal><Eyebrow>The Cornerstones</Eyebrow></Reveal>
          <div className="grid md:grid-cols-3 gap-px mt-10 border border-gold/15 bg-gold/10">
            {featured.map((b, i) => (
              <Reveal key={b.title} delay={i * 0.1} className="bg-ink">
                <div className="p-9 h-full hover:bg-ink-surface transition-colors duration-500">
                  <b.icon size={26} className="text-gold" strokeWidth={1.3} />
                  <h3 className="font-serif text-2xl mt-6">{b.title}</h3>
                  <p className="font-sans text-sm text-[#A19D98] leading-relaxed mt-4">{b.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-ink-deep">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal><Eyebrow>Full Register of Benefits</Eyebrow></Reveal>
          <div className="grid sm:grid-cols-2 gap-x-12 gap-y-2 mt-10">
            {rest.map((b, i) => (
              <Reveal key={b.title} delay={i * 0.06}>
                <div className="flex items-start gap-5 py-6 border-b border-gold/10">
                  <b.icon size={22} className="text-gold shrink-0 mt-1" strokeWidth={1.4} />
                  <div>
                    <h4 className="font-serif text-xl">{b.title}</h4>
                    <p className="font-sans text-sm text-[#A19D98] leading-relaxed mt-2">{b.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-ink">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Reveal>
            <IdCard size={30} className="text-gold mx-auto" strokeWidth={1.3} />
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-6">Claim your Membership ID.</h2>
            <p className="font-sans text-base text-[#A19D98] leading-relaxed mt-6 max-w-xl mx-auto">
              Verified members receive an instant digital ID and may order an embossed physical card,
              mailed directly to them.
            </p>
            <Link to="/membership?tab=order" data-testid="benefits-order-cta" className="group inline-flex items-center gap-3 mt-10 px-8 py-4 bg-gold text-black font-mono text-[11px] tracking-[0.2em] uppercase hover:bg-gold-text transition-colors">
              Order Membership ID <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
